module.exports = __webpack_public_path__ + "01d39046252a5e36368a2904e3242943.jpg";